const userSettingsEndpoint = `${process.env.VUE_APP_URL}/api/user/settings`
export default {
  namespaced: true,
  state: {
    company: {}
  },
  getters: {
    getCompany: state => state.company
  },
  mutations: {
    SET_COMPANY(state, company) {
      state.company = company
    },
    CLEAR_COMPANY(state) {
      state.company = {}
    } 
  },
  actions: {
  },
}
